export enum EventType {
	ACCOUNT_PAGE_READY = 'AccountPageReadyEvent',
	JOURNEY_STEP_CHANGED_EVENT = 'JourneyStepChangedEvent',
}
